export const FETCH_VEHICLE_DATA = '/fasTag/FETCH_VEHICLE_DATA';
export const SET_VEHICLE_DATA = 'fasTag/SET_VEHICLE_DATA';
export const SET_SEARCH_TEXT = 'fasTag/SET_SEARCH_TEXT';
export const FETCH_WALLET_BALANCE = 'fasTag/FETCH_WALLET_BALANCE';
export const SET_WALLET_BALANCE = 'fasTag/SET_WALLET_BALANCE';
export const AUTO_RECHARGE = 'fasTag/AUTO_RECHARGE';
export const RECHARGE_FASTAG = 'fasTag/RECHARGE_FASTAG';
export const SET_MIN_BALANCE = 'fasTag/SET_MIN_BALANCE';
